import { __awaiter, __decorate } from "tslib";
import { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { awaitProperty } from '@slickdeals/durango/dist/javascript/utilities/awaitProperty';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
/** The name of the module */
export const name = 'HotjarWidgetAdapter';
let HotjarWidgetAdapter = class HotjarWidgetAdapter {
    showHotjarWidget(triggerName) {
        return __awaiter(this, void 0, void 0, function* () {
            // If this.hotjar isn't initialized, wait for it to be available from the window
            // then assign it to this.hotjar
            if (!this.hotjar) {
                try {
                    yield awaitProperty('hj', window);
                    // Assigning to this.hotjar rather than using window.hj outright so if window.hj changes,
                    // we just have to update this one instance here rather than all instances throughout the file
                    this.hotjar = window.hj;
                }
                catch (error) {
                    Logger.error('Unable to initialize window.hj');
                    return;
                }
            }
            this.hotjar('trigger', triggerName);
        });
    }
};
HotjarWidgetAdapter = __decorate([
    injectable({
        key: name,
        scope: InjectorScope.Singleton,
    })
], HotjarWidgetAdapter);
export default HotjarWidgetAdapter;
